<resign-modal>
				<div id="{ props.modalId }" class="modal js-modal">

					<div class="modal__bg js-modal-close"></div>
					<div class="modal__content modal_filter">
						<div class="modal__content_inner">
							<h2 class="modal_title">Chiyo-co退会手続き</h2>
							
							<div class="withdrawal">
								<p>「chiyo-co」の退会手続きを行います。</p>
								<p class="notice">【注意事項】<br>退会をすると、今までの解析結果の履歴は全て抹消されます。<br>有料プランをご利用の場合は、解約をしないと退会の手続きはできません。</p>
							</div><!--/.withdrawal-->
							
							<button class="button button-primary" type="button" value="退会する" onclick="{(e)=>resign(e)}">退会する</button>
						</div><!--/.modal__content_inner-->
						<a class="btn_close_modal js-modal-close" style="cursor:pointer" onclick="{ onClose }"><img src="/assets/img/common/icn_close_modal.svg" alt="閉じる"></a>
					</div><!--modal__content-->


  <script>
    import di from "dependeny-injection";
    import { api as SettingStausApi } from "@model/setting-status.js";

    export default {
        state: {
            items: [],
            showButton: false
        },
        resign(e) {
            if (confirm('本当に退会してよろしいですか？')) {
                SettingStausApi.resign();
                window.$(this.$(`#${this.props.modalId}`)).fadeOut(100);
            }
        },
      onClose(e) {
        window.$(this.$(`#${this.props.modalId}`)).fadeOut(100);
      },
    };
  </script>
</resign-modal>